module.exports = __webpack_public_path__ + "img/CE0000_default.8fc15ec2.png";